import React from 'react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { Globe2Icon } from 'lucide-react';
interface Props {
  variant?: 'dark' | 'light';
  className?: string;
}
export function LanguageToggle({
  variant = 'dark',
  className = ''
}: Props) {
  const {
    lang,
    setLang
  } = useLang();
  const isDark = variant === 'dark';
  const baseBtn = `px-2.5 h-7 text-[11px] font-mono tracking-wider rounded-sm transition-colors`;
  const activeCls = isDark ? 'bg-gold text-navy-deep' : 'bg-navy-deep text-white';
  const inactiveCls = isDark ? 'text-slate-200 hover:text-white' : 'text-slate-500 hover:text-navy-deep';
  return <div className={`inline-flex items-center gap-1.5 ${className}`} data-id="element-655">
      <Globe2Icon className={`w-3.5 h-3.5 ${isDark ? 'text-gold' : 'text-slate-500'}`} aria-hidden="true" data-id="element-656" />
      <div className={`flex items-center p-0.5 rounded-sm ${isDark ? 'bg-black/30 border border-white/15 backdrop-blur-sm' : 'bg-slate-100 border border-slate-200'}`} data-id="element-657">
        <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} aria-label="Switch to English" className={`${baseBtn} ${lang === 'en' ? activeCls : inactiveCls}`} data-id="element-658">
          EN
        </button>
        <button type="button" onClick={() => setLang('es')} aria-pressed={lang === 'es'} aria-label="Cambiar a Español" className={`${baseBtn} ${lang === 'es' ? activeCls : inactiveCls}`} data-id="element-659">
          ES
        </button>
      </div>
    </div>;
}